import React, { useEffect } from "react";
import VerticalBarChart from "../../Components/Dashboard/Chart/VerticalBarChart";
import ConsulteCard from "../../Components/Dashboard/ConsulteCard";
import { ReactComponent as ArticleIcon } from "../../images/Dashboard/Article.svg";
import { ReactComponent as FileIcon } from "../../images/Dashboard/FileIcon.svg";
import { ReactComponent as ProductIcon } from "../../images/Dashboard/ProductIcon.svg";
import { ReactComponent as PageIcon } from "../../images/Dashboard/PageIcon.svg";
import DoughnutChart from "../../Components/Dashboard/Chart/DoughnutChart";
import { useDispatch, useSelector } from "react-redux";
import { getNumbers } from "../../REDUX/actions/stats";
import Loading from "../../Components/Common/Loading";

const DashboardView = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getNumbers()); // eslint-disable-next-line
  }, []);
  const { dbStats, statsLoading } = useSelector((state) => state.statsReducer);
  console.log(dbStats);

  return statsLoading || !dbStats ? (
    <Loading />
  ) : (
    <div className="d-flex align-items-center gap-4 w-90 m-auto">
      <div className="d-flex flex-column gap-4 flex-1">
        <ConsulteCard
          Title="Nombre de pages actuelles"
          Count={dbStats.pagesNumber}
          icon="bi bi-file-earmark-text-fill"
          Icon={PageIcon}
          FooterText="Consulter les pages"
          LinkTo="/pages"
          ColorCard="#2980B9"
        />
        <ConsulteCard
          Title="Nombre de fichiers"
          Count={dbStats.filesNumber}
          icon="bi bi-folder-fill"
          Icon={FileIcon}
          FooterText="Consulter les fichiers"
          LinkTo="/files"
          ColorCard="#27AE60"
        />
        <ConsulteCard
          Title="Nombre de demande de contact"
          Count={dbStats.contactsNumber}
          icon="bi bi-envelope-fill"
          Icon={ArticleIcon}
          FooterText="Consulter les demandes"
          LinkTo="/contact"
          ColorCard="#C0392B"
        />
        <ConsulteCard
          Title="Nombre d’utilisateurs sur l'admin"
          Count={dbStats.utilisateursNumber}
          icon="bi bi-people-fill"
          Icon={ArticleIcon}
          FooterText="Consulter les utilisateurs"
          LinkTo="/users"
          ColorCard="#F39C12"
        />
      </div>

      <div className="d-flex flex-column gap-4 flex-1">
        <ConsulteCard
          Title="Nombre d’articles"
          Count={dbStats.articleNumber}
          icon="bi bi-journal-richtext"
          Icon={ArticleIcon}
          FooterText="Consulter les articles"
          LinkTo="/blog"
          ColorCard="#16A085"
        />
        <ConsulteCard
          Title="Nombre des offres d'emploi"
          Count={dbStats.jobsNumber}
          icon="bi bi-briefcase-fill"
          Icon={FileIcon}
          FooterText="Consulter les offres d'emploi"
          LinkTo="/emploi"
          ColorCard="#8E44AD"
        />
        <ConsulteCard
          Title="Nombre des articles de presse (presse parution et téléchargement)"
          Count={dbStats.presseNumber}
          icon="bi bi-newspaper"
          Icon={FileIcon}
          FooterText="Consulter les articles de presse"
          LinkTo="/presse-parution"
          ColorCard="#2C3E50"
        />
        <ConsulteCard
          Title="Nombre de partenaires"
          Count={dbStats.partenairesNumber}
          icon="bi bi-people-fill"
          Icon={FileIcon}
          FooterText="Consulter les partenaires"
          LinkTo="/nos-partenaires"
          ColorCard="#7F8C8D"
        />
      </div>
    </div>
  );
};

export default DashboardView;
